import { useBoolean } from 'react-use'

import agent from 'agent'
import { handlePaymentLinkRequest } from 'components/rbac-settings/Payment'
import useAuth from 'hooks/use-auth'
import toast from 'lib/toast'
import { messageFromResponseError } from 'utils/strings'

export function usePaymentSetup() {
  const { currentTeamId, paywallStatus } = useAuth()
  const [isSubmitting, setIsSubmitting] = useBoolean(false)

  const handleCheckout = async () => {
    if (isSubmitting) {
      return
    }
    const updatePaymentStatusKeys = [
      'PAYMENT_METHOD_DETACHED_PAYMENT_DUE',
      'PAYMENT_METHOD_INVALID_PAYMENT_DUE'
    ]

    try {
      /**
       * if a customer record already exists, as it does in the status keys defined above, the ADD PAYMENT
       * link will link out to Stripe's portal page for the user to remedy the payment issue.
       */
      if (updatePaymentStatusKeys.includes(paywallStatus?.key)) {
        await handlePaymentLinkRequest(setIsSubmitting, currentTeamId)
      } else {
        setIsSubmitting(true)
        const checkoutResponse = await agent.get(
          `/payments/checkout?teamId=${currentTeamId}`
        )
        if (
          typeof checkoutResponse.data !== 'string' ||
          checkoutResponse.data?.length < 1
        ) {
          toast({
            type: 'error',
            text: 'There was a problem redirecting to the payment processor. Please try again.'
          })
          return
        }
        window.location.href = checkoutResponse.data
      }
      // redirect to the Stripe url we get from the backend to complete the checkout/setup process
    } catch (e) {
      toast({
        type: 'error',
        text: messageFromResponseError(
          e,
          // this is explicitly different from the error above so we can determine the origin if it occurs
          'There was a problem initiating payment. Please try again.'
        )
      })
      setIsSubmitting(false)
    }
  }

  return { handleCheckout, isSubmitting }
}
